import { toCappedCountText } from "@mgdx/shared/src/utils/toCappedCountText";
import { cva, cx, VariantProps } from "cva";
import { type HTMLAttributes } from "react";

import styles from "./index.module.css";

export const variants = cva({
  base: styles.base,
  variants: {
    variant: {
      dot: styles.dot,
      solid: styles.solid,
      lighted: styles.lighted,
    },
    color: {
      primary: styles.primary,
      caution: styles.caution,
      transparent: styles.transparent,
    },
    size: {
      s: styles.s,
      m: styles.m,
      l: styles.l,
      xl: styles.xl,
    },
  },
  defaultVariants: {
    variant: "dot",
    size: "m",
  },
});

export type BadgeProps = VariantProps<typeof variants> &
  Omit<HTMLAttributes<HTMLSpanElement>, "contentEditable"> & {
    number?: number;
  };

export const Badge = ({ className, variant, color, size, number, ...props }: BadgeProps) => (
  <span className={cx(className, variants({ variant, color, size }))} {...props}>
    {!!number && toCappedCountText(number)}
  </span>
);
